import { ErrorString, InvalidOperationException } from "../../shared/index.js";
export const first = (source, predicate) => {
    if (predicate) {
        return first2(source, predicate);
    }
    else {
        return first1(source);
    }
};
const first1 = async (source) => {
    const firstElement = await source[Symbol.asyncIterator]().next();
    if (firstElement.done === true) {
        throw new InvalidOperationException(ErrorString.NoElements);
    }
    return firstElement.value;
};
const first2 = async (source, predicate) => {
    for await (const value of source) {
        if (predicate(value) === true) {
            return value;
        }
    }
    throw new InvalidOperationException(ErrorString.NoMatch);
};
